export default __webpack_public_path__ + "static/media/Pistol_1.29be775d.png";